class RadioService {
  nowPlaying = async () => {
    const response = await fetch(this.getAPI(), {
      method: "GET",
      credentials: "same-origin",
    });

    return response.json();
  };

  getAPI = (env = process.env.APP_ENV) => {
    switch (env) {
      case "production":
      case "prod":
        return "https://www.bruzz.be/api/radio/current";
      default:
        return "https://stag.bruzz.be/api/radio/current";
    }
  };
}

const service = new RadioService();
export default service;
